import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-contact-edit',
    templateUrl: './contact-edit.component.html',
    styleUrls: ['./contact-edit.component.scss'],
    standalone: false
})
export class ContactEditComponent implements OnInit {
  contactId: string;

  constructor(private readonly route: ActivatedRoute) {}

  ngOnInit(): void {
    this.contactId = this.route.snapshot.params['id'];
  }
}
